import styled from "styled-components";

export const CheckoutContainer = styled.div`
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  display: flex;
  max-width: 70rem;
  width: 100%;
  gap: 1rem;

  @media (max-width: 770px) {
    flex-direction: column;
    min-width: 100%;
  }

  .title {
    display: flex;
    align-items: center;
    font-style: normal;
    font-size: 1.25rem;
    font-weight: 700;
    color: #460259;
    gap: 0.75rem;

    span {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f2b705;
      border-radius: 50%;
      height: 2rem;
      width: 2rem;
    }
  }
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;

  .titleHead {
    background: rgba(70, 2, 89, 0.15);
    border-radius: 5px;
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
    line-height: 125%;
    margin-top: 1rem;
    font-weight: 500;
    color: #434343;
  }
`;

export const CardGray = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: rgba(222, 222, 222, 0.25);
  flex-wrap: wrap;
  border: 1px solid #dedede;
  border-radius: 5px;
  padding: 1.5rem;
  width: 100%;
  gap: 1rem;

  .dataClient {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.75rem;

    @media (max-width: 475px) {
      grid-template-columns: 1fr;
    }
  }

  .dataAddress {
    display: flex;
    flex-wrap: wrap;
    width: 28rem;
    gap: 0.75rem;

    @media (max-width: 475px) {
      display: grid;
      width: 100%;
      grid-template-columns: 1fr;
    }
  }
`;

export const CardPayment = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #dedede;
  border-radius: 5px;
  padding: 1.5rem;
  width: 100%;
  gap: 1rem;

  .containerPayment {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;

    p {
      font-size: 0.875rem;
      line-height: 150%;
      font-weight: 700;
      color: rgba(67, 67, 67, 0.75);
    }

    ul li {
      display: flex;
      background: rgba(222, 222, 222, 0.25);
      border: 1px solid #dedede;
      border-radius: 5px;
      margin: 0.5rem 0;
      padding: 1rem;
      height: 3.5rem;
      gap: 1.25rem;
      width: 100%;

      label {
        display: flex;
        align-items: center;
        color: rgba(67, 67, 67, 0.75);
        font-size: 0.875rem;
        line-height: 150%;
        font-weight: 700;
        gap: 0.5rem;

        span {
          color: rgba(67, 67, 67, 0.75);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 150%;
        }
      }

      @media (max-width: 425px) {
        span {
          display: none;
        }
        gap: 0.5rem;
      }
    }

    .cartData {
      border: 1px solid #dedede;
      border-radius: 5px;
      padding: 1.5rem;

      h2 {
        margin-bottom: 1.5rem;
        font-size: 0.875rem;
        line-height: 180%;
        font-weight: 700;
        color: #460259;
      }

      .cartDataContent {
        display: flex;
        flex-direction: column;
      }

      .cvv {
        display: flex;
        align-items: center;
        padding-top: 0.75rem;
        gap: 0.75rem;

        label {
          width: 8rem;
          text-align: end;
          color: rgba(67, 67, 67, 0.75);
          font-size: 0.875rem;
          line-height: 150%;
          font-weight: 700;
          gap: 0.5rem;
        }

        input {
          border: 1px solid #9e9e9e;
          border-radius: 3px;
          padding: 0.5rem 1rem;
          width: 4rem;
        }
      }
    }

    .quantityPay {
      display: grid;
      grid-template-columns: 8rem 12rem;
      border-top: 1px solid #dedede;
      align-items: center;
      margin-top: 1rem;
      padding-top: 1rem;
      gap: 0.75rem;
      width: 21rem;

      label {
        text-align: end;
        color: rgba(67, 67, 67, 0.75);
        font-size: 0.875rem;
        line-height: 150%;
        font-weight: 700;
        gap: 0.5rem;
      }

      select {
        background: rgba(222, 222, 222, 0.25);
        border: 1px solid #9e9e9e;
        padding: 0.5rem 0.5rem;
        border-radius: 3px;
      }

      @media (max-width: 425px) {
        grid-template-columns: 1fr;
        width: 100%;
      }
    }
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    background: #5e0577;
    border-radius: 5px;
    border: none;
    font-size: 0.75rem;
    margin-left: auto;
    font-weigth: 600;
    height: 2.5rem;
    color: #fafafa;
    width: 15rem;

    :hover {
      background: #460259;
    }
  }
`;

export const SummaryContainer = styled.div`
  display: flex;
  border: 1px solid #e0e0e0;
  height: max-content;
  border-radius: 5px;
  margin-top: 1rem;
  padding-top: 0.5rem;
`;
